module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-grouper",
    class: {
      'bar-mode': _vm.barMode
    }
  }, [_c('group', {
    class: {
      collapsed: _vm.collapseAll
    },
    attrs: {
      "data": _vm.grouped(),
      "tooltip": "Expand/Collapse All"
    },
    on: {
      "collapse": function($event) {
        _vm.handleCollapseAll()
      },
      "drag-drop": function($event) {
        _vm.handleMove($event)
      }
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised barMode",
    class: {
      'md-accent': _vm.barMode
    },
    attrs: {
      "slot": "header"
    },
    nativeOn: {
      "click": function($event) {
        _vm.barMode = !_vm.barMode
      }
    },
    slot: "header"
  }, [_c('md-icon', [_vm._v("short_text")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Toggle Bar Mode")])], 1)], 1), _vm._v(" "), _c('droppable', {
    staticClass: "groups",
    on: {
      "drag-drop": function($event) {
        _vm.handleMove($event, _vm.numGroups + 1)
      }
    }
  }, [_c('div', _vm._l((_vm.groupNumsSortedByTotal), function(groupNum) {
    return _c('group', {
      key: groupNum,
      attrs: {
        "group-num": groupNum,
        "data": _vm.grouped(groupNum),
        "group-name": _vm.groupNames[groupNum]
      },
      on: {
        "group-name-change": function($event) {
          _vm.handleGroupNameChange($event)
        },
        "drag-drop": function($event) {
          _vm.handleMove($event, groupNum)
        }
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-100b19be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataGrouper.vue
// module id = 255
// module chunks = 1